<script setup>
import { ref } from "vue";
import { useInscripcionTours } from "@/store/inscripcionTours";
import heroImage from "@/assets/img/background/image3.png";
import { loadSlim } from "tsparticles-slim";

import Step1DatosPersonales from "@/components/Torneo/Step1DatosPersonales.vue";
import Step2DatosCombate from "@/components/Torneo/Step2DatosCombate.vue";
import Step3MetodoPago from "@/components/Torneo/Step3MetodoPago.vue"; // mismo archivo, renombrado lógicamente
import Stepper from "@/components/Torneo/Stepper.vue";

const store = useInscripcionTours();
const activeStep = ref(0);
const stepsEnabled = ref([true, false, false]);

// Términos — manejados desde el padre para que el Stepper se oculte
const mostrarTerminos = ref(false);
const mostrarTerminosStripe = ref(false);

const particleConfig = {
  background: { color: "transparent" },
  particles: {
    number: { value: 40 },
    color: { value: "#00aaff" },
    shape: { type: "circle" },
    opacity: { value: 0.25 },
    size: { value: 3 },
    move: { enable: true, speed: 1.2, direction: "none", outModes: "out" },
  },
};
const particlesInit = async (engine) => await loadSlim(engine);

function nextStep() {
  if (activeStep.value < stepsEnabled.value.length - 1) {
    stepsEnabled.value[activeStep.value + 1] = true;
    activeStep.value += 1;
  }
}

function prevStep() {
  if (activeStep.value > 0) activeStep.value -= 1;
}

function confirmarInscripcion() {
  store.resetFormulario();
  activeStep.value = 0;
  stepsEnabled.value = [true, false, false];
}
</script>

<template>
  <section class="registro-wrapper">
    <div class="hero-bg-image" :style="{ backgroundImage: `url(${heroImage})` }"></div>
    <div class="hero-gradient"></div>
    <Particles id="tsparticles" :init="particlesInit" :options="particleConfig" />
    <div class="smoke-layer"></div>

    <div class="registro-content">
      <div class="form-box">
        <!-- Stepper — se oculta cuando se muestran los términos -->
        <Stepper
          v-if="!mostrarTerminos && !mostrarTerminosStripe"
          v-model="activeStep"
          :steps-enabled="stepsEnabled"
        />

        <!-- Paso 1: Datos personales + dirección + redes -->
        <Step1DatosPersonales v-if="activeStep === 0" @next-step="nextStep" />

        <!-- Paso 2: Datos de combate + términos -->
        <Step2DatosCombate
          v-if="activeStep === 1"
          :mostrar-terminos="mostrarTerminos"
          @toggle-terminos="(val) => (mostrarTerminos = val)"
          @next-step="nextStep"
          @prev-step="prevStep"
        />

        <!-- Paso 3: Método de pago -->
        <Step3MetodoPago
          v-if="activeStep === 2"
          :mostrar-terminos-stripe="mostrarTerminosStripe"
          @toggle-terminos-stripe="(val) => (mostrarTerminosStripe = val)"
          @prev-step="prevStep"
          @confirmar-inscripcion="confirmarInscripcion"
        />
      </div>
    </div>
  </section>
</template>

<style scoped>
.registro-wrapper {
  position: relative;
  min-height: 100vh;
  padding: 2rem 1rem 3rem;
  overflow: hidden;
}
.hero-bg-image {
  position: absolute;
  inset: 0;
  background-size: cover;
  background-position: center;
  filter: brightness(0.75) contrast(1.2);
  z-index: 1;
}
.hero-gradient {
  position: absolute;
  inset: 0;
  background: linear-gradient(
    180deg,
    rgba(0, 0, 0, 0.9) 0%,
    rgba(0, 20, 45, 0.7) 50%,
    rgba(0, 0, 0, 0.95) 100%
  );
  z-index: 2;
}
#tsparticles {
  position: absolute;
  inset: 0;
  z-index: 3;
}
.smoke-layer {
  position: absolute;
  inset: 0;
  background: url("https://c4.wallpaperflare.com/wallpaper/448/699/737/abstract-digital-art-3d-abstract-lines-wallpaper-preview.jpg");
  opacity: 0.22;
  mix-blend-mode: lighten;
  animation: smokeMove 20s infinite linear;
  z-index: 4;
}
@keyframes smokeMove {
  0% {
    transform: translateY(0) scale(1.2);
  }
  100% {
    transform: translateY(-20%) scale(1.25);
  }
}
.registro-content {
  position: relative;
  z-index: 10;
  display: flex;
  justify-content: center;
  align-items: flex-start;
}
.form-box {
  background: #fff;
  border-radius: 16px;
  padding: 2rem;
  width: 100%;
  max-width: 860px;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.35);
}

@media (max-width: 600px) {
  .form-box {
    padding: 1.25rem;
    border-radius: 12px;
  }
  .registro-wrapper {
    padding: 4rem 0.75rem 2rem;
  }
}
</style>
